import { Dialog } from '@base-ui/react/dialog'
import type { ReactElement, ReactNode } from 'react'
import { cx } from '@/lib/cx'

type TriggerElement = ReactElement<Record<string, unknown>>

type ModalProps = {
  /** Element that opens the modal, e.g. a kit <Button>; trigger props are merged onto it. */
  trigger?: TriggerElement
  title: ReactNode
  description?: ReactNode
  children?: ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
  /** Extra classes on the popup (e.g. wide essay reading pane). */
  className?: string
}

// Brand-styled wrapper over Base UI Dialog: focus trap, Escape-to-close and
// focus return come from the primitive; never use @base-ui/react directly
// outside components/ui (R7's "no unstyled default ever ships" guard).
export function Modal({
  trigger,
  title,
  description,
  children,
  open,
  onOpenChange,
  className,
}: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      {trigger != null && <Dialog.Trigger render={trigger} />}
      <Dialog.Portal>
        <Dialog.Backdrop className="modal-backdrop" />
        <Dialog.Popup className={cx('modal-popup', className)}>
          <Dialog.Title className="modal-popup__title">{title}</Dialog.Title>
          {description != null && (
            <Dialog.Description className="modal-popup__description">
              {description}
            </Dialog.Description>
          )}
          {children != null && <div className="mt-4">{children}</div>}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export const ModalClose = Dialog.Close
